import TournamentsPage from './tournaments';
import WebsitesPage from './websites';
import CoachesPackPage from './coaches-pack';
import SponsorshipsPage from './sponsorships';

export {
  TournamentsPage,
  WebsitesPage,
  CoachesPackPage,
  SponsorshipsPage,
}
